import { defaultEntityState } from '@core/state/entities/entity';
import {
  mergeEntityState,
  removeEntities,
  removeEntitiesByFilter,
} from '@core/state/entities/entity.helpers';
import { ISearch } from '@core/state/entities/search/search.entity';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import { createReducer, on } from '@ngrx/store';
import { entityKey } from '@core/state/entities/entity-name-map';

export const searchEntityReducer = createReducer(
  defaultEntityState<ISearch>(),
  on(
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.projectUpdated,
    (state, props) =>
      mergeEntityState(
        entityKey.searches,
        state,
        props,
        (aq) => aq.projectId === props.projectId
      )
  ),
  on(
    projectDetailActions.registered,
    projectDetailActions.created,
    (state, props) => mergeEntityState(entityKey.searches, state, props)
  ),
  on(projectDetailActions.searchRemoved, (state, props) =>
    removeEntities(entityKey.searches, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (projChild) => projChild.projectId === props.projectId
    )
  ),
);
